module.exports = __webpack_public_path__ + "static/img/share-show-banner.7e1e943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/share-show-banner.png
// module id = 6wtq
// module chunks = 212